import React, { memo } from "react";
import { SectionBasedProduct } from "@brandclub/common-ui";
import { ConciergeOrderData } from "../types/conversation";
import { OrderWidget } from "./OrderWidget";

interface OrderListProps {
  orders: ConciergeOrderData[];
  productMetadataMap: Map<string, SectionBasedProduct>;
}

export const OrderList: React.FC<OrderListProps> = memo(
  ({ orders, productMetadataMap }) => {
    if (!orders || orders.length === 0) {
      return null;
    }

    return (
      <div className="tw:flex tw:flex-col tw:gap-4 tw:mt-4">
        {orders.map((order) => (
          <OrderWidget
            key={`${order.orderId}-${order.retailerId}`}
            order={order}
            productMetadataMap={productMetadataMap}
          />
        ))}
      </div>
    );
  }
);

OrderList.displayName = "OrderList";
